// SPDX-FileCopyrightText: 2025 Slant Tech LLC
// SPDX-License-Identifier: GPL-3.0-or-later

import { useState } from 'react';

function CommentMarker({ comment, position, index, isSelected, onClick }) {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    onClick(comment);
  };

  const markerClasses = [
    'comment-marker',
    'pointer-events-auto',
    comment.resolved && 'resolved',
    isSelected && 'selected',
  ].filter(Boolean).join(' ');

  // Use content field (backend uses content, not body)
  // Strip metadata tags and image markdown for plain text preview
  const commentText = (comment.content || '')
    .replace(/<!--.*?-->/gs, '')
    .replace(/!\[.*?\]\(.*?\)(\{.*?\})?/g, '')
    .trim();

  return (
    <>
      {/* Marker */}
      <div
        className={markerClasses}
        style={{
          left: position.x,
          top: position.y,
        }}
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        title={commentText.substring(0, 100)}
      >
        {index}
      </div>

      {/* Tooltip on hover */}
      {isHovered && !isSelected && (
        <div
          className="tooltip animate-fade-in pointer-events-none"
          style={{
            left: position.x + 20,
            top: position.y - 10,
          }}
        >
          <div className="flex items-start gap-2 mb-2">
            <span className={`badge ${comment.resolved ? 'badge-resolved' : 'badge-open'}`}>
              {comment.resolved ? 'Resolved' : 'Open'}
            </span>
            {comment.component_ref && (
              <span className="text-xs font-mono text-st-accent">
                {comment.component_ref}
              </span>
            )}
          </div>
          <p className="text-sm text-st-text line-clamp-3 font-body">
            {commentText}
          </p>
          {comment.author && (
            <p className="text-xs text-st-muted mt-2 font-mono">
              — {comment.author}
            </p>
          )}
        </div>
      )}
    </>
  );
}

export default CommentMarker;
